import { SPH_2026_CAMPAIGN, isSph2026Active } from './sph-2026';

export const UOB_SBF_2026_CAMPAIGN = {
  code: 'uob-sbf-2026',
  path: '/uob-sbf-2026',
  storageKey: 'smw_campaign',
  /** Services shown on campaign home / booking */
  serviceCodes: ['ARR', 'DEP', 'PTP', 'TWAT'] as const,
  /** Vehicle category display names / cat codes allowed (Vellfire/Alphard/Denza) */
  vehicleCategoryIdHint: 9,
};

export type CampaignCode =
  | typeof UOB_SBF_2026_CAMPAIGN.code
  | typeof SPH_2026_CAMPAIGN.code
  | '';

/**
 * Ops kill-switch via .env (after 31 Jul 2026 set to false):
 *   REACT_APP_UOB_SBF_2026_ENABLED=false
 * Default true when unset (local/UAT convenience).
 */
export const isUobSbf2026EnvEnabled = () => {
  const flag = process.env.REACT_APP_UOB_SBF_2026_ENABLED;
  if (flag === undefined || flag === '') {
    return true;
  }
  return flag === 'true' || flag === '1';
};

export const setCampaign = (code: CampaignCode) => {
  if (code) {
    // sessionStorage: same-tab booking flow
    // localStorage: survives email-verify / reset links opened in a new tab
    sessionStorage.setItem(UOB_SBF_2026_CAMPAIGN.storageKey, code);
    localStorage.setItem(UOB_SBF_2026_CAMPAIGN.storageKey, code);
  } else {
    sessionStorage.removeItem(UOB_SBF_2026_CAMPAIGN.storageKey);
    localStorage.removeItem(UOB_SBF_2026_CAMPAIGN.storageKey);
  }
};

export const getCampaign = (): CampaignCode => {
  const stored = (sessionStorage.getItem(UOB_SBF_2026_CAMPAIGN.storageKey) ||
    localStorage.getItem(UOB_SBF_2026_CAMPAIGN.storageKey) ||
    '') as CampaignCode;

  if (stored === UOB_SBF_2026_CAMPAIGN.code && isUobSbf2026EnvEnabled()) {
    return stored;
  }
  if (stored === SPH_2026_CAMPAIGN.code && isSph2026Active()) {
    return stored;
  }
  return '';
};

export const isUobSbf2026Campaign = () =>
  getCampaign() === UOB_SBF_2026_CAMPAIGN.code;

export const isSph2026Campaign = () => getCampaign() === SPH_2026_CAMPAIGN.code;

export const clearCampaign = () => setCampaign('');

/** Home path for logo / Book Now / BACK — keeps campaign context when active */
export const getCampaignHomePath = () => {
  if (isUobSbf2026Campaign()) {
    return UOB_SBF_2026_CAMPAIGN.path;
  }
  if (isSph2026Campaign()) {
    return SPH_2026_CAMPAIGN.path;
  }
  return '/';
};

export {
  SPH_2026_CAMPAIGN,
  isSph2026Active,
  isSph2026EnvEnabled,
  isSph2026WithinWindow,
} from './sph-2026';
